import { render, staticRenderFns } from "./dMediaLangPie.vue?vue&type=template&id=9cb93846&"
import script from "./dMediaLangPie.vue?vue&type=script&lang=js&"
export * from "./dMediaLangPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports